import { render } from "./patient-profile-modal.vue?vue&type=template&id=29894a63"
import script from "./patient-profile-modal.vue?vue&type=script&lang=js"
export * from "./patient-profile-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__